class BundleModal extends HTMLElement {
  constructor() {
    super();
    this.currentBundle = [];
    this.currentProductIndex = 0;
    this.boundKeydownHandler = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.overlay = this.querySelector('.bundle-modal__overlay');
    this.closeBtn = this.querySelector('.bundle-modal__close button');
    this.bundleStack = this.querySelector('.bundle-stack');
    this.productContent = this.querySelector('.bundle-modal__product-content');
    
    this.bindEvents();
    
    window.bundleModalInstance = this;
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.boundKeydownHandler);
  }

  bindEvents() {
    if (!this.closeBtn || !this.overlay) return;
    
    this.closeBtn.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    
    document.addEventListener('keydown', this.boundKeydownHandler);
  }

  handleKeydown(e) {
    if (e.key === 'Escape' && this.style.display !== 'none') {
      this.close();
    }
  }

  open(productHandle, bundleProducts, productIndex = 0) {
    this.currentBundle = bundleProducts.split(',');
    this.currentProductIndex = productIndex;
    
    this.style.display = 'block';
    document.body.style.overflow = 'hidden';
    
    this.createBundleStack();
    
    this.loadProduct(productHandle);
  }

  close() {
    this.style.display = 'none';
    document.body.style.overflow = '';
  }

  createBundleStack() {
    if (!this.bundleStack) return;
    
    this.bundleStack.innerHTML = '';
    
    this.currentBundle.forEach((productHandle, index) => {
      const stackItem = document.createElement('div');
      stackItem.className = `bundle-stack__item ${index === this.currentProductIndex ? 'active' : ''}`;
      stackItem.dataset.productHandle = productHandle.trim();
      stackItem.dataset.index = index;
      
      stackItem.innerHTML = `
        <div style="width: 100%; height: 100%; background: #f0f0f0; display: flex; align-items: center; justify-content: center; font-size: 10px;">
          ${index + 1}
        </div>
      `;
      
      stackItem.addEventListener('click', () => {
        this.switchToProduct(index, productHandle.trim());
      });
      
      this.bundleStack.appendChild(stackItem);
      
      // Load product image for stack
      this.loadStackImage(stackItem, productHandle.trim());
    });
  }

  async loadStackImage(stackItem, productHandle) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();
      
      if (product.featured_image) {
        stackItem.innerHTML = `<img src="${product.featured_image}" alt="${product.title}" />`;
      }
    } catch (error) {
      console.error('Error loading stack image:', error);
    }
  }

  switchToProduct(index, productHandle) {
    this.currentProductIndex = index;
    
    if (this.bundleStack) {
      this.bundleStack.querySelectorAll('.bundle-stack__item').forEach((item, i) => {
        item.classList.toggle('active', i === index);
      });
    }
    
    this.loadProduct(productHandle);
  }

  loadProduct(productHandle) {
    try {
      const allProductBlocks = this.productContent.querySelectorAll('.bundle-product-block');
      allProductBlocks.forEach(block => {
        block.style.display = 'none';
      });
      
      const targetProductBlock = this.productContent.querySelector(`[data-product-handle="${productHandle}"]`);
      
      if (targetProductBlock) {
        targetProductBlock.style.display = 'block';
        console.log('✅ Showing product block for:', productHandle);
      } else {
        console.warn('⚠️ Product block not found for handle:', productHandle);
        if (this.productContent) {
          const fallbackDiv = document.createElement('div');
          fallbackDiv.innerHTML = `<div style="display: flex; justify-content: center; align-items: center; height: 200px;">Product "${productHandle}" not found</div>`;
          allProductBlocks.forEach(block => block.style.display = 'none');
          this.productContent.appendChild(fallbackDiv);
        }
      }
      
    } catch (error) {
      console.error('Error loading product:', error);
      if (this.productContent) {
        this.productContent.innerHTML = '<div>Error loading product</div>';
      }
    }
  }


}
customElements.define('bundle-modal', BundleModal);

document.addEventListener('DOMContentLoaded', function() {
  const bundleQuickviewButtons = document.querySelectorAll('.how-to-style-it .bundle-quickview-btn');
  
  bundleQuickviewButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productHandle = this.dataset.productHandle;
      const bundleProducts = this.dataset.bundleProducts;
      const bundleIndex = parseInt(this.dataset.bundleIndex);
      
      if (productHandle && bundleProducts && window.bundleModalInstance) {
        window.bundleModalInstance.open(productHandle, bundleProducts, bundleIndex);
      }
    });
  });
});

window.BundleModal = BundleModal;